import React, { FC } from "react";

import { Typography } from "ui-library/atoms";
import { ContentBox } from "ui-library/layouts";
import i18n from "core/i18n";

import { SubjectFields } from "./SubjectFields";
import { AddressFieldsContainer } from "./AddressFields";

export const ContactPersonSection: FC = () => {
    const { t } = i18n.useTranslation();

    return (
        <>
            <ContentBox>
                <Typography variant="h4" markDown={t("vehicle.change.contractCancellation.newContractPerson")} />
            </ContentBox>
            <SubjectFields sectionName={"contactPerson"} />
            <AddressFieldsContainer sectionName={"contactPerson.address"} />
        </>
    );
};
